import ArrowDownIcon from 'assets/svgs/ArrowDownIcon';
import ArrowUpIcon from 'assets/svgs/ArrowUpIcon';
import classNames from 'classnames';
import Checkbox from 'modules/Common/Components/Checkbox';
import InfiniteScroll from 'react-infinite-scroll-component';
import styled from 'styled-components';
import FormDetailListingCard from '../Components/FormDetailListingCard';
import { deleteForm, getForms, resetForms } from '../actions';
import { Suspense, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import SelectSearch from 'modules/Analytics/Shared/SelectSearch';
import GlobalCustomButton from 'modules/Common/Components/GlobalCustomButton';
import AddIcon from 'assets/svgs/AddIcon';
import { useHistory } from 'react-router-dom';
import CreateFormFooter from '../Components/CreateFormFooter';
import ConfirmDialog from 'modules/Common/Components/ConfirmDialog';
import FormsDefaultPage from 'modules/Settings/FormsDefaultPage';
import SkeletonFormListing from '../Components/SkeletonFormListing';
import SkeletonHeader from '../Components/SkeletonHeaderFormHandler';
import SkeletonFormListingHeader from '../Components/SkeletonFormListingHeader';
// import SkeletonFormListingHeader from '../Components/SkeletonFormListingHeader';
// import SkeletonHeader from '../Components/SkeletonHeaderFormHandler';

const commonCSS = {
  color: '#5E7079',
  fontFamily: 'Roboto',
  fontSize: '18px',
  fontStyle: 'normal',
  fontWeight: 500,
  lineHeight: '18px',
};
const commonFlexCSS = {
  display: 'flex',
  alignItems: 'center',
  // flex: 1,
};
const Wrapper = styled.div`
  .default-page {
    height: calc(100vh - 140px);
    display: flex;
    justify-content: center;
  }
  .skeleton-form-listing {
    display: flex !important;
    justify-content: space-between !important;
    width: 100% !important;
    margin-bottom: 8px;
  }
  .aud-Infinite-scroll {
    @media all and (max-width: 1439px) and (max-height: 729px) {
      height: calc(100vh - 39vh) !important;
    }
    @media all and (min-width: 1920px) and (min-height: 915px) and (-webkit-device-pixel-ratio: 1) {
      height: 71vh !important;
    }
  }
  .aud-Infinite-scroll-bottom {
    padding-bottom: 80px;
    @media all and (max-height: 729px) {
      padding-bottom: 90px !important;
    }
  }
  .no-forms-found-text {
    display: flex;
    justify-content: center;
    margin-top: 15%;
    ${commonCSS};
  }
  @media all and (max-width: 1280px) {
    .text-ellipse {
      width: 120px !important;
    }
    .name {
      font-size: 13px !important;
    }
    .campaign {
      font-size: 12px !important;
    }
    .url {
      font-size: 13px !important;
      .custom-tooltip-text {
        width: 120px !important;
      }
    }
  }
  @media all and (max-width: 1024px) and (-webkit-device-pixel-ratio: 1.25) {
    .ant-typography-ellipsis-single-line {
      width: 90px !important;
    }
  }
`;
const FormDetailHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const SearchBar = styled.div`
  .search-bar {
    max-width: 692px !important;
    width: 692px !important;
  }
  .search-wraper .search-bar span.clear-search {
    margin-top: 0px !important;
    display: flex !important;
  }
  .refresh-search svg {
    width: 19px !important;
    height: 19px !important;
  }
  @media all and (max-width: 1280px) {
    .search-bar {
      max-width: 530px !important;
      width: 530px !important;
    }
  }
  @media all and (max-width: 1280px) and (max-height: 729px) and (-webkit-device-pixel-ratio: 1.25) {
    .search-bar {
      max-width: 550px !important;
      width: 550px !important;
    }
  }
  @media all and (max-width: 1280px) and (-webkit-device-pixel-ratio: 1) {
    .search-bar {
      max-width: 500px !important;
      width: 500px !important;
    }
  }
  @media all and (max-width: 1280px) and (-webkit-device-pixel-ratio: 1.25) {
    .search-bar {
      max-width: 380px !important;
      width: 380px !important;
    }
  }
  .search-input {
    height: 38px;
    margin-top: 0px !important;
    width: calc(100% - 70px) !important;
  }
`;
const Header = styled.div`
  margin: 24px 0 8px 0;
  ${commonFlexCSS};
  .checkbox-wrapper {
    margin: 0 !important;
    display: flex !important;
    align-items: center !important;
    label span {
      padding: 0 !important;
      width: 19px !important;
      height: 19px !important;
    }
  }
  .arrowIconClass {
    opacity: 0.5;
  }
  .name {
    ${commonFlexCSS};
    ${commonCSS};
    flex: 2;
    @media all and (max-width: 1024px) and (-webkit-device-pixel-ratio: 1.25) {
      flex: 7.8% !important;
    }
  }
  .url {
    ${commonFlexCSS};
    ${commonCSS};
    flex: 1;
  }
  .submission {
    ${commonFlexCSS};
    ${commonCSS};
    flex: 1;
    @media all and (max-width: 1280px) {
      font-size: 13px !important;
    }
  }
  .updated {
    ${commonFlexCSS};
    ${commonCSS};
    flex: 1;
    @media all and (max-width: 1280px) {
      font-size: 13px !important;
    }
  }
  .setting {
    width: 30px;
    ${commonCSS};
  }
`;
const DialogWrapper = styled.div`
  .setting-delete-dialog {
    width: 326px !important;
    .message {
      font-family: 'Roboto' !important;
      font-weight: 700 !important;
      line-height: 26px !important;
      font-size: 20px !important;
    }
  }
  .message-footer a {
    font-family: 'Roboto' !important;
    line-height: 20px !important;
    font-weight: 700 !important;
  }
  z-index: 17;
  top: 50%;
  left: 50%;
  position: fixed;
  .back-overlay {
    position: fixed;
    background: grey;
    opacity: 0.2;
    height: 100vh;
    width: 100vw;
    top: 0;
    left: 0;
  }
`;
export const FormListing = () => {
  // Redux States
  const userForms = useSelector((state: RootState) => state.forms.forms.data);
  const userFormsLoading = useSelector((state: RootState) => state.forms.forms.loading);
  const totalForms = useSelector((state: RootState) => state.forms.forms.totalCount);
  const formsSearchTerm = useSelector((state: RootState) => state.forms.searchTerm);

  // Local States
  const [searchTerm, setSearchTerm] = useState('');
  const [selectAll, setSelectAll] = useState(false);
  const [selectedFormIds, setSelectedFormIds] = useState<number[]>([]);
  const [excludedFormIds, setExcludedFormIds] = useState<number[]>([]);
  const [sortType, setSortType] = useState('');
  const [sortBy, setSortBy] = useState('');
  const [isOpenDeletePopUp, setIsOpenDeletePopUp] = useState(false);
  const [tempObj, setTempObj] = useState({ id: 0, name: '' });
  const [firstTimeRender, setFirstTimeRender] = useState(true);
  const [isFirstEnter, setIsFirstEnter] = useState(true);
  const skeletonArray = Array.from({ length: 5 }).map((_, index) => <SkeletonFormListing />);

  // Local variables
  const history = useHistory();
  var localStorage_totalForms = localStorage.getItem('totalForms');
  const isSelected: boolean = selectAll ? totalForms - excludedFormIds?.length > 0 : selectedFormIds?.length > 0;
  const footerDeleteMessage: string = `${
    isSelected ? 'Selected Form Handler(s)' : `${tempObj.name}`
  } will be deleted permanently. Click on “Delete” to proceed.`;

  // || ------ Functions ------ ||
  const getParams = (offset?: number, search_term?: string, sort_by?: string, sort_type?: string) => {
    return {
      offset: offset ? offset : 0,
      limit: 20,
      ...(search_term && { search_term: search_term }),
      ...(sort_by && { sort_by: sort_by }),
      ...(sort_type && { sort_type: sort_type }),
    };
  };

  const clearSelection = () => {
    setSelectAll(false);
    setSelectedFormIds([]);
    setExcludedFormIds([]);
  };

  const fetchData = () => {
    if (!userFormsLoading) getForms(getParams(userForms?.length, searchTerm, sortType !== '' ? sortBy : undefined, sortType));
  };

  const handleOnClickCheckbox = (checked: boolean, id: number) => {
    let updatedFormIds: number[] = [],
      updatedExcludedFormIds: number[] = [];
    if (checked) {
      if (selectAll) {
        updatedExcludedFormIds = excludedFormIds.filter((f_id) => f_id !== id);
      } else {
        updatedFormIds = [...selectedFormIds, id];
      }
    } else {
      if (selectAll) {
        updatedExcludedFormIds = [...excludedFormIds, id];
      } else {
        updatedFormIds = [...selectedFormIds].filter((f_id) => f_id !== id);
      }
    }
    if (selectAll) setExcludedFormIds(updatedExcludedFormIds);
    else setSelectedFormIds(updatedFormIds);
  };

  const onClickSelectAllCheckbox = (checked: boolean) => {
    if (checked) {
      setSelectAll(true);
      setExcludedFormIds([]);
    } else {
      clearSelection();
    }
  };

  // Mini Component
  const ColumnHeaderWithSortButtons = ({ headerName }: any) => (
    <>
      <span style={{ paddingLeft: `${headerName == 'Name' && '24px'}` }}>{headerName}</span>
      <span
        style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', paddingLeft: '6px', gap: 3 }}
        onClick={() => {
          if (headerName.toLowerCase() !== sortBy) {
            setSortType('ASC');
          } else {
            if (sortType === '') setSortType('ASC');
            else if (sortType === 'ASC') setSortType('DESC');
            else if (sortType === 'DESC') setSortType('');
          }
          setSortBy(headerName.toLowerCase());
        }}
      >
        <span className={classNames('d-flex align-items-center', { arrowIconClass: sortType !== 'ASC' || sortBy !== headerName.toLowerCase() })}>
          <ArrowUpIcon />
        </span>
        <span className={classNames('d-flex align-items-center', { arrowIconClass: sortType !== 'DESC' || sortBy !== headerName.toLowerCase() })}>
          <ArrowDownIcon />
        </span>
      </span>
    </>
  );

  // useEffects
  useEffect(() => {
    resetForms();
    getForms(getParams());
    setFirstTimeRender(false);
  }, []);

  useEffect(() => {
    if (!firstTimeRender) {
      resetForms();
      getForms(getParams(undefined, searchTerm, sortType !== '' ? sortBy : undefined, sortType));
    }
  }, [sortType, sortBy]);

  const handleClearSearch = () => {
    if (searchTerm.trim()) {
      resetForms();
      getForms(getParams(undefined, undefined, sortType !== '' ? sortBy : undefined, sortType));
    } else {
      setSearchTerm('');
    }
  };

  return (
    <Wrapper>
      {Number(localStorage_totalForms) === 0 ? (
        <div className="default-page">
          <FormsDefaultPage />
        </div>
      ) : Number(localStorage_totalForms) > 0 &&
        userFormsLoading &&
        searchTerm?.length === 0 &&
        sortBy === '' &&
        sortType === '' &&
        !(totalForms > 0 && userFormsLoading) ? (
        <>
          <SkeletonHeader />
          <SkeletonFormListingHeader />
          {skeletonArray}
        </>
      ) : Number(localStorage_totalForms) === 0 && userFormsLoading ? (
        <></>
      ) : (
        <>
          <FormDetailHeader>
            <SearchBar>
              <SelectSearch
                placeholder={'Search by Form Handler name, Campaign name or end point URL'}
                onSearchInput={(e: any) => {
                  setSearchTerm(e);
                  setIsFirstEnter(true);
                }}
                onClearSearch={() => handleClearSearch()}
                onSubmit={() => {
                  if (searchTerm.trim() !== formsSearchTerm && isFirstEnter) {
                    setIsFirstEnter(false);
                    resetForms();
                    getForms(getParams(undefined, searchTerm, sortType !== '' ? sortBy : undefined, sortType));
                  }
                }}
              />
            </SearchBar>
            <GlobalCustomButton
              btnText={'Create New Form Handler'}
              disabled={false}
              onClick={() => history.push('/settings/forms/create_form')}
              border={'none'}
              padding={''}
              bgColor={'#1EC252'}
              color={'#fff'}
              customIcon={<AddIcon />}
              borderRadius={'6px'}
              fontSize={'16px'}
              boxShadow={''}
              width="auto"
            />
          </FormDetailHeader>
          {userForms.length !== 0 || !userFormsLoading || (!searchTerm.length && sortBy === '' && sortType === '') ? (
            <Header>
              <div className="name">
                <span style={{ paddingLeft: '26px', display: 'flex', alignItems: 'center' }}>
                  <Checkbox
                    onClick={(e: any) => onClickSelectAllCheckbox(e.target.checked)}
                    checked={
                      (selectAll && excludedFormIds.length === 0) || (totalForms === selectedFormIds.length && !searchTerm && totalForms !== 0)
                    }
                    disabled={totalForms === 0}
                  />
                  <ColumnHeaderWithSortButtons headerName="Name" />
                </span>
              </div>
              <div className="url">
                <span>URL</span>
              </div>
              <div className="submission">
                <ColumnHeaderWithSortButtons headerName="Submissions" />
              </div>
              <div className="updated">
                <ColumnHeaderWithSortButtons headerName="Updated" />
              </div>
              <div className="setting"></div>
            </Header>
          ) : null}
          {/* User List Cards */}
          <InfiniteScroll
            dataLength={userForms?.length}
            next={fetchData}
            hasMore={userForms?.length < totalForms}
            loader={false}
            className={classNames((selectedFormIds.length > 0 || selectAll) && 'aud-Infinite-scroll-bottom', 'aud-Infinite-scroll', {
              loadingFlag: 'loading',
            })}
            height="66vh"
          >
            {userForms?.map((form, index) => (
              <FormDetailListingCard
                key={index}
                form={form}
                handleOnClickCheckbox={handleOnClickCheckbox}
                selectedFormIds={selectedFormIds}
                selectAll={selectAll}
                excludedFormIds={excludedFormIds}
                setIsOpenDeletePopUp={setIsOpenDeletePopUp}
                setTempObj={setTempObj}
              />
            ))}
            {userForms.length === 0 && searchTerm.length > 0 && !userFormsLoading ? (
              <div className="no-forms-found-text">No form handler(s) found against your search</div>
            ) : null}
            {(userForms.length === 0 && !userFormsLoading && !searchTerm.length) || userFormsLoading ? (
              <>
                <div>
                  {!(totalForms > 0 && userFormsLoading) ? (
                    <div style={{ paddingTop: '24px' }}>
                      <SkeletonFormListingHeader />
                    </div>
                  ) : null}
                  {skeletonArray}
                </div>
              </> // Render skeleton loader while waiting for search results
            ) : null}
          </InfiniteScroll>
          {(selectedFormIds.length > 0 || (selectAll && excludedFormIds.length !== totalForms)) && (
            <Suspense fallback={<> </>}>
              <CreateFormFooter
                selectAll={selectAll}
                btnText={`Delete`}
                disableButton={false}
                onClickClearSelection={() => {
                  clearSelection();
                }}
                onClick={() => {
                  setIsOpenDeletePopUp(true);
                }}
                footerType={'delete'}
                selectedFormIds={selectedFormIds}
                excludedFormIds={excludedFormIds}
                totalForms={totalForms}
              />
            </Suspense>
          )}
        </>
      )}
      {isOpenDeletePopUp ? (
        <DialogWrapper>
          <div className="back-overlay" />
          <ConfirmDialog
            className="setting-delete-dialog"
            cancel="Cancel"
            confirm={'Delete'}
            onConfirm={() => {
              localStorage.removeItem('totalForms');
              if (isSelected) {
                const count = totalForms - (selectAll ? totalForms - excludedFormIds?.length : selectedFormIds?.length);
                localStorage.setItem('totalForms', count?.toString());
              } else {
                const count = totalForms - 1;
                localStorage.setItem('totalForms', count?.toString());
              }
              isSelected ? deleteForm(selectedFormIds, undefined, selectAll, excludedFormIds, searchTerm) : deleteForm([tempObj.id], tempObj.name);
              setIsOpenDeletePopUp(false);
              isSelected && setSelectAll(false);
              clearSelection();
            }}
            onCancel={() => setIsOpenDeletePopUp(false)}
            title={footerDeleteMessage}
            titleQuestion={null}
          />
        </DialogWrapper>
      ) : null}
    </Wrapper>
  );
};
